import { Observable } from 'rxjs';
import { GGFirmwareWSDTO } from '../../components/gg-firmware-verification/gg-firmware-verification.component';

export abstract class GgFirmwareVerificationAdapter {
  abstract checkFirmware(extraId: string): Observable<GGFirmwareWSDTO[]>;
}
